"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _Control = _interopRequireDefault(require("@icare/rhythm-form-react/lib/elements/Control"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The MultiPickList pure component, a component for creating searchable
 * dropdowns that a user can select values from
 */
var MultiPickList = function MultiPickList(_ref) {
  var id = _ref.id,
      autoLoad = _ref.autoLoad,
      clearable = _ref.clearable,
      disabled = _ref.disabled,
      error = _ref.error,
      helpText = _ref.helpText,
      hideDropdown = _ref.hideDropdown,
      _isAsync = _ref.isAsync,
      isLoading = _ref.isLoading,
      label = _ref.label,
      listOptions = _ref.listOptions,
      name = _ref.name,
      value = _ref.value,
      noResultsText = _ref.noResultsText,
      _onInputChange = _ref.onInputChange,
      onResultSelect = _ref.onResultSelect,
      _onInputFocus = _ref.onInputFocus,
      _onInputBlur = _ref.onInputBlur,
      _optionLoaderFunc = _ref.optionLoaderFunc,
      placeholder = _ref.placeholder,
      required = _ref.required,
      _resetInput = _ref.resetInput,
      status = _ref.status,
      statusMessage = _ref.statusMessage,
      tabSelectsValue = _ref.tabSelectsValue,
      tooltip = _ref.tooltip,
      menuRenderer = _ref.menuRenderer,
      optionRenderer = _ref.optionRenderer,
      width = _ref.width,
      searchPromptText = _ref.searchPromptText,
      isMulti = _ref.isMulti,
      hideSelectedOptions = _ref.hideSelectedOptions,
      closeMenuOnSelect = _ref.closeMenuOnSelect;
  var _status = status;
  var _statusMessage = statusMessage;

  if (error) {
    _status = 'error';
    _statusMessage = error;
  } //css variables


  var multiSelectStyles = {
    bgColor: '#f5f5f5',
    selectedColor: '#D0006F',
    white: '#ffffff',
    black: '#000000',
    boxShadow: '0 0 0 1px #f5f5f5',
    border: '1px solid #cccccc',
    controlMinHeight: '50px',
    controlPadding: '5px 15px',
    optionPadding: '10px 25px',
    labelColor: '#666666'
  }; //const SelectComponent = isAsync ? Async : Select;

  var classes = (0, _classnames.default)({
    'pick-list': true,
    'hide-dropdown': hideDropdown
  });

  var Menu = function Menu(props) {
    var optionSelectedLength = props.getValue().length || 0;
    return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Menu, props, optionSelectedLength < 10 ? props.children : /*#__PURE__*/_react.default.createElement("div", {
      style: {
        margin: 15
      }
    }, "A maximum of 10 policies can be selected"));
  };

  var isValidNewOption = function isValidNewOption(inputValue, selectValue) {
    return inputValue.length > 0 && selectValue.length < 5;
  };

  var colourStyles = {
    option: function option(styles, _ref2) {
      var isDisabled = _ref2.isDisabled,
          isFocused = _ref2.isFocused,
          isSelected = _ref2.isSelected;

      var getBackgroundColor = function getBackgroundColor() {
        if (isDisabled) {
          return null;
        }

        if (isSelected) {
          return multiSelectStyles.bgColor;
        }

        if (isFocused) {
          return multiSelectStyles.white;
        }

        return null;
      };

      return _objectSpread(_objectSpread({}, styles), {}, {
        padding: multiSelectStyles.optionPadding,
        backgroundColor: getBackgroundColor(),
        color: isSelected ? multiSelectStyles.selectedColor : multiSelectStyles.black,
        ':active': _objectSpread(_objectSpread({}, styles[':active']), {}, {
          backgroundColor: !isDisabled && (isSelected ? multiSelectStyles.white : multiSelectStyles.white)
        }),
        ':hover': {
          cursor: 'pointer'
        }
      });
    },
    control: function control(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        boxShadow: multiSelectStyles.boxShadow,
        border: multiSelectStyles.border,
        minHeight: multiSelectStyles.controlMinHeight,
        padding: multiSelectStyles.controlPadding,
        ':hover': {
          border: multiSelectStyles.border,
          boxShadow: multiSelectStyles.boxShadow
        },
        ':active': {
          border: multiSelectStyles.border,
          boxShadow: multiSelectStyles.boxShadow
        }
      });
    },
    multiValue: function multiValue(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        backgroundColor: multiSelectStyles.bgColor
      });
    },
    multiValueLabel: function multiValueLabel(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: multiSelectStyles.black
      });
    },
    multiValueRemove: function multiValueRemove(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: multiSelectStyles.labelColor,
        ':hover': {
          cursor: 'pointer'
        }
      });
    }
  };
  var optionalProps = {};

  if (menuRenderer) {
    optionalProps.menuRenderer = menuRenderer;
  }

  if (optionRenderer) {
    optionalProps.optionRenderer = optionRenderer;
  }

  if (searchPromptText) {
    optionalProps.searchPromptText = searchPromptText;
  } // TODO: Seems no aria-invalid attribute available, need to investigate it


  return /*#__PURE__*/_react.default.createElement(_Control.default, {
    className: classes,
    helpText: helpText,
    label: label,
    name: id || name,
    required: required,
    status: _status,
    statusMessage: _statusMessage,
    tooltip: tooltip,
    width: width
  }, /*#__PURE__*/_react.default.createElement(_reactSelect.default, _extends({
    "aria-describedby": _statusMessage,
    "aria-labelledby": id,
    autoload: autoLoad,
    clearable: clearable,
    isLoading: isLoading,
    name: name,
    value: value,
    defaultValue: [],
    isValidNewOption: isValidNewOption,
    components: {
      Menu: Menu
    },
    noResultsText: noResultsText,
    onChange: onResultSelect,
    options: listOptions,
    placeholder: placeholder,
    required: required,
    disabled: disabled,
    tabSelectsValue: tabSelectsValue,
    isMulti: isMulti,
    hideSelectedOptions: hideSelectedOptions,
    closeMenuOnSelect: closeMenuOnSelect,
    styles: colourStyles,
    inputRenderer: function inputRenderer(props) {
      return /*#__PURE__*/_react.default.createElement("input", _extends({
        autoComplete: "nope",
        id: id || name
      }, props));
    }
  }, optionalProps)));
};

MultiPickList.defaultProps = {
  autoLoad: false,
  clearable: false,
  disabled: false,
  error: null,
  helpText: null,
  hideDropdown: false,
  isAsync: false,
  isLoading: false,
  label: null,
  listOptions: [],
  noResultsText: 'No results found',
  onInputChange: function onInputChange() {},
  optionLoaderFunc: function optionLoaderFunc() {},
  onInputFocus: function onInputFocus() {},
  onInputBlur: function onInputBlur() {},
  placeholder: null,
  required: false,
  resetInput: true,
  status: null,
  statusMessage: null,
  tooltip: null,
  tabSelectsValue: false,
  value: null,
  width: null,
  menuRenderer: null,
  optionRenderer: null,
  searchPromptText: null,
  id: null,
  isMulti: false,
  closeMenuOnSelect: false,
  hideSelectedOptions: false,
  getValue: function getValue() {
    return [];
  },
  children: undefined
};
MultiPickList.propTypes = {
  /**
   * whether an async picklist should call it's optionLoaderFunc before any input is entered
   */
  autoLoad: _propTypes.default.bool,

  /**
   * whether or not the user can clear the input text, this will render a clickable cross
   * that hides when loading and when the user has not selected anything for the first time only
   */
  clearable: _propTypes.default.bool,

  /**
   * indicates whether the input should be disabled
   */
  disabled: _propTypes.default.bool,

  /**
   * indicates if there is an error
   */
  error: _propTypes.default.node,

  /**
   * help text to be displayed below field
   */
  helpText: _propTypes.default.string,

  /**
   * hides the dropdown, even if it has results to show when true
   */
  hideDropdown: _propTypes.default.bool,

  /**
   * used to tell the picklist whether to render as an async picklist or not
   */
  isAsync: _propTypes.default.bool,

  /**
   * used to put the picklist into loading state or not
   */
  isLoading: _propTypes.default.bool,

  /**
   * field label
   */
  label: _propTypes.default.string,

  /**
   * possible options to select from, only used for non-async picklists
   */
  listOptions: _propTypes.default.array,

  /**
   * name of the input
   */
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.array,
  id: _propTypes.default.string,

  /**
   * text to show if no results are found
   */
  noResultsText: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),

  /**
   * called when the user types into the input
   */
  onInputChange: _propTypes.default.func,

  /**
   * called when a result is selected
   */
  onResultSelect: _propTypes.default.func.isRequired,

  /**
   * called for async picklists whenever input changes to load options
   */
  optionLoaderFunc: _propTypes.default.func,

  /**
   * placeholder text to put in field
   */
  placeholder: _propTypes.default.string,

  /**
   * whether the input is required in the form
   */
  required: _propTypes.default.bool,

  /**
   * whether to reset the input whenever a user blurs the field
   */
  resetInput: _propTypes.default.bool,

  /**
   * current status of input
   */
  status: _propTypes.default.oneOf(['error', 'warning', 'info', 'success']),

  /**
   * status message to be displayed below input
   */
  statusMessage: _propTypes.default.node,

  /**
   * Indicates whether a tab press will select the currently hovered value,
   * note that this has been known to cause certain tab trap issues when set to true
   * and after clearing your input with backspace - test thoroughly if needed
   */
  tabSelectsValue: _propTypes.default.bool,

  /**
   * tooltip to be displayed to user
   */
  tooltip: _propTypes.default.string,
  width: _propTypes.default.string,
  onInputFocus: _propTypes.default.func,
  onInputBlur: _propTypes.default.func,
  menuRenderer: _propTypes.default.func,
  optionRenderer: _propTypes.default.func,
  searchPromptText: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),

  /**
   * used to put the picklist into multi mode
   */
  isMulti: _propTypes.default.bool,

  /**
   * applicable only for multi select picklist. when this is set to true, the menu will not close once an option is selected
   */
  closeMenuOnSelect: _propTypes.default.bool,

  /**
   * applicable only for multi select picklist. when this is set to true, the menu will not remove selected options
   */
  hideSelectedOptions: _propTypes.default.bool,
  getValue: _propTypes.default.func,
  children: _propTypes.default.node
};
var _default = MultiPickList;
exports.default = _default;
//# sourceMappingURL=MultiPickList.js.map